const MAIN_BUNDLE_PATH_RE = /\/static\/js\/main\.[a-f0-9]+\.js/;
const MAIN_BUNDLE_HTML_RE = /<script[^>]+src="([^"]*\/static\/js\/main\.[a-f0-9]+\.js[^"]*)"/;

function bundleIdFromSrc(src) {
  if (!src) return null;
  const path = src.split('?')[0];
  const filename = path.split('/').pop();
  if (!filename) return null;

  if (MAIN_BUNDLE_PATH_RE.test(path) || filename === 'main.js' || filename === 'bundle.js') {
    return filename;
  }

  return null;
}

export function getLoadedMainBundleId() {
  for (const script of document.querySelectorAll('script[src]')) {
    const bundleId = bundleIdFromSrc(script.getAttribute('src'));
    if (bundleId) return bundleId;
  }
  return null;
}

export async function fetchServerMainBundleId() {
  const response = await fetch('/index.html', {
    cache: 'no-store',
    credentials: 'same-origin',
    headers: {
      'Cache-Control': 'no-cache, no-store, must-revalidate',
      Pragma: 'no-cache',
    },
  });

  if (!response.ok) {
    return null;
  }

  const html = await response.text();
  const productionMatch = html.match(MAIN_BUNDLE_HTML_RE);
  if (productionMatch) {
    return bundleIdFromSrc(productionMatch[1]);
  }

  const devMatch = html.match(/<script[^>]+src="([^"]*main\.js[^"]*)"/);
  if (devMatch) {
    return bundleIdFromSrc(devMatch[1]);
  }

  return null;
}
